module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "close.8833abb1.svg";